var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkMoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6877",
    "data-name": "Group 6877",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.438,
    height: 12.447,
    viewBox: "0 0 12.438 12.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 12.438,
    height: 12.447,
    fill: "#aeb4bf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M6.392,12.446A6.4,6.4,0,0,1,4.2.038a.447.447,0,0,1,.387.011.427.427,0,0,1,.191.512,10.581,10.581,0,0,0-.264,1.129,5.306,5.306,0,0,0,.718,3.554A5.449,5.449,0,0,0,9.2,7.923a5.332,5.332,0,0,0,2.627-.242.472.472,0,0,1,.388,0,.422.422,0,0,1,.187.555,6.273,6.273,0,0,1-1.548,2.39,6.364,6.364,0,0,1-3.56,1.749c-.085.013-.171.023-.257.029-.215.014-.431.025-.646.037",
    transform: "translate(0 0)",
    fill: "#aeb4bf"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMoon);
export default __webpack_public_path__ + "static/media/dark-moon.49b990211f908d05627e82e2c299854b.svg";
export { ForwardRef as ReactComponent };